/* import __COLOCATED_TEMPLATE__ from './launchpad-upsell-card.hbs'; */
var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { computed } from '@ember/object';
import { CurrencyDisplayPreference, BitcoinDisplayPreference, BitcoinAccountStatus } from '@square/dashboard-protos/models/squareup/bitty/model';
import { inject as service } from '@ember/service';
import { Money } from '@square/dashboard-protos/models/squareup/common/currency';
import { CurrencyCode } from '@square/dashboard-protos/models/squareup/common/currency_codes';
import formatMoney from '@banking/ui/utils/format-money';
let BitcoinLaunchpadUpsellCard = (_dec = computed('args.walletDetails.{walletBalance.amount,withholdingToWalletConversionRate}', 'args.bitcoinAccount.{currencyDisplayPreference,bitcoinDisplayPreference}'), _dec2 = computed('args.bitcoinAccount.{bitcoinDisplayPreference,currencyDisplayPreference}', 'balanceDisplay'), _dec3 = computed('args.bitcoinAccount.nextConversionTime'), _class = class BitcoinLaunchpadUpsellCard extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "formatter", _descriptor2, this);
    _defineProperty(this, "BitcoinAccountStatus", BitcoinAccountStatus);
  }
  get balanceDisplay() {
    const satoshis = this.args.walletDetails?.walletBalance?.amount ?? 0;
    const conversionRate = this.args.walletDetails?.withholdingToWalletConversionRate ?? 0;
    const currencyDisplayPreference = this.args.bitcoinAccount?.currencyDisplayPreference;

    // If currency display preference is USD, show USD amount
    if (currencyDisplayPreference === CurrencyDisplayPreference.BTC) {
      return Money.create({
        amount: satoshis,
        currencyCode: CurrencyCode.BTC
      });
    } else {
      const btcAmount = satoshis / 100000000;
      const usdAmount = Math.round(btcAmount * conversionRate);
      return Money.create({
        amount: usdAmount,
        currencyCode: CurrencyCode.USD
      });
    }
  }
  get formattedBalanceDisplay() {
    if (this.args.bitcoinAccount?.currencyDisplayPreference === CurrencyDisplayPreference.USD) {
      return formatMoney(this.balanceDisplay, this.formatter, true, this.intl);
    } else {
      const formatAsCents = this.args.bitcoinAccount?.bitcoinDisplayPreference === BitcoinDisplayPreference.SATOSHI;
      return formatMoney(this.balanceDisplay, this.formatter, true, this.intl, formatAsCents);
    }
  }
  get formattedNextConversionTime() {
    const nextConversionTime = this.args.bitcoinAccount?.nextConversionTime;

    // Format conversion time to 9PM format or use fallback text
    if (nextConversionTime) {
      const milliseconds = nextConversionTime.seconds * 1000 + nextConversionTime.nanos / 1000000;
      const date = new Date(milliseconds);
      // Round up to next hour if not exactly on the hour
      if (date.getTime() % 3600000 !== 0) {
        date.setHours(date.getHours() + 1);
        date.setMinutes(0);
      }
      return date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        hour12: true
      });
    }
    return this.intl.t('banking.bitcoin.wallet.tonight');
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "balanceDisplay", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "balanceDisplay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "formattedBalanceDisplay", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "formattedBalanceDisplay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "formattedNextConversionTime", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "formattedNextConversionTime"), _class.prototype), _class);
export { BitcoinLaunchpadUpsellCard as default };